import { OrderOperationType } from 'api/types/entity/account/order';
import { ValidateOrderParams } from 'api/types/params';

import { OrderFormType } from '../../common/forms/orderForm/type';

import { parseOrderValuesForCreate } from './parseOrderValuesForCreate';

export const parseOrderValuesForValidate = (
  orderType: OrderOperationType,
  values: OrderFormType
): ValidateOrderParams => parseOrderValuesForCreate(orderType, values);
